import { render, staticRenderFns } from "./joinMessage.vue?vue&type=template&id=4af23fbb&scoped=true&"
import script from "./joinMessage.vue?vue&type=script&lang=js&"
export * from "./joinMessage.vue?vue&type=script&lang=js&"
import style0 from "./joinMessage.vue?vue&type=style&index=0&id=4af23fbb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af23fbb",
  null
  
)

export default component.exports